import React, { useState, useEffect, useRef } from 'react';
import { Card, Form, Row, Col, Button, Accordion } from 'react-bootstrap';
import { CompactPicker } from 'react-color';
import QuillInput from './QuilEditor';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import UploadHeroImg from './UploadHeroimg.js';

const HeroSectionEditor = ({ section, onChange, setEditingElement, Gid, editingElement }) => {
    const isFirstRender = useRef(true);
    const [activeKey, setActiveKey] = useState(['2']);
    const [imageLoaded, setImageLoaded] = useState(true);
    const editingTimeoutRef = useRef(null);
    const lastEditingElementRef = useRef(null);


    useEffect(() => {
        return () => {
            if (editingTimeoutRef.current) {
                clearTimeout(editingTimeoutRef.current);
            }
        };
    }, []);


    const initializeLayout = (data) => {
        const layoutorder = data.layoutorder || ['content', 'image'];
        return {
            ...data,
            layoutorder,
            contentposition: layoutorder[0] === "content" ? "left" : "right",
            imageposition: layoutorder[1] === "image" ? "right" : "left",
        };
    };
    const [formData, setFormData] = useState(initializeLayout(section));

    useEffect(() => {

        const handleImageLoad = () => {
            setImageLoaded(true);
        };

        const handleImageError = () => {
            setImageLoaded(false);
        };
        const imgElement = document.createElement("img");
        imgElement.onload = handleImageLoad;
        imgElement.onerror = handleImageError;
        imgElement.src = formData.heroimage;

        return () => {
            imgElement.onload = null;
            imgElement.onerror = null;
        };
    }, [formData]);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (section._id && section._id !== formData._id) {
            setFormData(initializeLayout(section));
        }
    }, [section]);

    const handleSetEditingElement = (element) => {
        if (editingTimeoutRef.current) {
            clearTimeout(editingTimeoutRef.current);
            editingTimeoutRef.current = null;
        }
        lastEditingElementRef.current = element;
        setEditingElement(element);
    };

    const handleClearEditingElement = () => {
        if (editingTimeoutRef.current) {
            clearTimeout(editingTimeoutRef.current);
        }
        editingTimeoutRef.current = setTimeout(() => {
            if (editingElement === lastEditingElementRef.current) {
                setEditingElement(null);
            }
        }, 200);
    };

    const updateField = (field, value) => {
        setFormData((prev) => {
            const updated = { ...prev, [field]: value };
            onChange && onChange(updated);
            return updated;
        });
        handleSetEditingElement(field);
    };

    const handleButtonChange = (field, value) => {
        setFormData((prev) => {
            const updated = {
                ...prev,
                button: {
                    ...prev.button,
                    [field]: value,
                },
            };
            onChange && onChange(updated);
            return updated;
        });
    };

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const newOrder = Array.from(formData.layoutorder);
        const [moved] = newOrder.splice(result.source.index, 1);
        newOrder.splice(result.destination.index, 0, moved);

        setFormData((prev) => {
            const updated = {
                ...prev,
                layoutorder: newOrder,
                contentposition: newOrder[0] == "content" ? "left" : "right",
                imageposition: newOrder[1] == "image" ? "right" : "left",
            };
            onChange(updated);
            return updated;
        });
    };

    const swapPositions = () => {
        const newOrder = [...formData.layoutorder].reverse();
        console.log(newOrder, 'newOrder');

        setFormData((prev) => {
            const updated = {
                ...prev,
                layoutorder: newOrder,
                contentposition: newOrder[0] == "content" ? "left" : "right",
                imageposition: newOrder[1] == "image" ? "right" : "left",
            };
            onChange(updated);
            return updated;
        });
    };

    const handleUrl = (data) => {
        console.log(data);
        console.log(typeof data);
        // updateForm({ logourl: data.route })
        // setLogourl(data)
        setFormData((prev) => {
            const updated = {
                ...prev,
                heroimage: data,
            };
            onChange(updated);
            return updated;
        });
    }
    return (
        <div className='overflow-auto'>
            <div className="d-flex justify-content-between align-items-center w-100">
                <div className='d-flex align-items-center'>
                    <div className='settingIcon'>
                        <i class="fas fa-cogs"></i>
                    </div>
                    <div>
                        <h6 className="mb-0">Hero Section Settings</h6>
                        <label className="text-muted fw-6">Configure your hero section appearance</label>
                    </div>
                </div>
                <div className="d-flex align-items-center">
                    <label className="me-2 mb-0">Active</label>
                    <label className="switch">
                        <input
                            className="form-control"
                            type="checkbox"
                            checked={formData.isactive}
                            onChange={(e) => updateField('isactive', e.target.checked)}
                        />
                        <span className="slider round"></span>
                    </label>
                </div>
            </div>
            <Card className='mt-3 border shadow-0 overflow-hidden'>
                <Accordion activeKey={activeKey} onSelect={(e) => setActiveKey(e)} >

                    {/* Layout Configuration Section */}
                    <Accordion.Item eventKey="1" className="border-0">
                        <Accordion.Header className="p-0 bg-transparent border-bottom">
                            <Form.Label className="fw-bold mb-0 d-flex align-items-center"><i class="fas fa-columns me-2 text-primary"></i> Layout Configuration</Form.Label>
                        </Accordion.Header>
                        <Accordion.Body className="p-0">
                            <div className="bg-light p-3 rounded-3">
                                <DragDropContext onDragEnd={handleDragEnd}>
                                    <Droppable droppableId="layout" direction="horizontal">
                                        {(provided) => (
                                            <div
                                                className="d-flex align-items-center justify-content-center position-relative me-2"
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                style={{ minHeight: '100px' }}
                                            >
                                                {formData.layoutorder.map((type, index) => (
                                                    <Draggable draggableId={type} index={index} key={type}>
                                                        {(provided, snapshot) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className={`flex-grow-1 text-center p-3 border rounded-3 mx-2 shadow-2 ${snapshot.isDragging
                                                                    ? 'border-primary shadow'
                                                                    : 'border-light'
                                                                    }`}
                                                                style={{
                                                                    maxWidth: '160px',
                                                                    minHeight: '80px',
                                                                    backgroundColor: 'white',
                                                                    cursor: 'grab',
                                                                    transition: 'all 0.2s ease',
                                                                    transform: snapshot.isDragging ? 'rotate(3deg)' : 'none',
                                                                    ...provided.draggableProps.style,
                                                                }}
                                                            >
                                                                <div className="d-flex flex-column align-items-center justify-content-center h-100">
                                                                    <i
                                                                        className={`bi bi-${type === 'content' ? 'text-paragraph' : 'image'
                                                                            } fs-3 mb-2`}
                                                                    ></i>
                                                                    <span className="fw-medium">
                                                                        {type === 'content' ? 'Content' : 'Image'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))}

                                                <div className="position-absolute me-3 " style={{
                                                    left: '50%',
                                                    top: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    zIndex: 10
                                                }}>
                                                    <Button
                                                        variant="outline-primary"
                                                        className="rounded-circle p-0 d-flex align-items-center justify-content-center swapicon"
                                                        onClick={swapPositions}
                                                        title="Swap positions"
                                                    >
                                                        <i className="bi bi-arrow-left-right fs-6 text-white"></i>
                                                    </Button>
                                                </div>

                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                                <div className="text-center text-muted small mt-2">
                                    Drag elements or click swap to change layout
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>

                    {/* Content Section */}
                    <Accordion.Item eventKey="2" className=" border-0">
                        <Accordion.Header className="p-0 bg-transparent border-bottom">
                            <Form.Label className="fw-bold mb-0 d-flex align-items-center"><i class="fas fa-pen-alt me-2 text-primary"></i> Content</Form.Label>
                        </Accordion.Header>
                        <Accordion.Body className="p-0">
                            <Card className="border-0 shadow-sm">
                                <Card.Body>
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-bold'>Subtitle</Form.Label>
                                        <QuillInput
                                            value={formData.subtitle}
                                            onChange={(val) => updateField('subtitle', val)}
                                            onFocus={() => handleSetEditingElement('subtitle')}
                                            onBlur={handleClearEditingElement}
                                            editingElement={editingElement}
                                            fieldName="subtitle"
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-bold'>Title</Form.Label>
                                        <QuillInput
                                            value={formData.title}
                                            onChange={(val) => updateField('title', val)}
                                            onFocus={() => handleSetEditingElement('title')}
                                            onBlur={handleClearEditingElement}
                                            editingElement={editingElement}
                                            fieldName="title"
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-bold'>Description</Form.Label>
                                        <QuillInput
                                            value={formData.description}
                                            onChange={(val) => updateField('description', val)}
                                            onFocus={() => handleSetEditingElement('description')}
                                            onBlur={handleClearEditingElement}
                                            style={{ height: '200px', marginBottom: '50px' }}
                                            editingElement={editingElement}
                                            fieldName="description"
                                        />
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                        </Accordion.Body>
                    </Accordion.Item>

                    {/* Appearance Section */}
                    <Accordion.Item eventKey="3" className="border-0">
                        <Accordion.Header className="p-0 bg-transparent border-bottom">
                            <Form.Label className="fw-bold mb-0 d-flex align-items-center"><i class="fas fa-palette me-2 text-warning"></i> Appearance</Form.Label>
                        </Accordion.Header>
                        <Accordion.Body className="p-0">
                            <Card className="border-0 shadow-sm">
                                <Card.Body>
                                    <div>
                                        <Form.Label>Background Color</Form.Label>
                                        <Form.Group className="mb-3">
                                            <CompactPicker
                                                color={formData.backgroundcolor}
                                                onChangeComplete={(color) => {
                                                    updateField('backgroundcolor', color.hex);
                                                    setEditingElement(null);
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                    <Form.Group className="">
                                        {/* <Form.Label>Hero Image</Form.Label> */}
                                        <div className="">
                                            <UploadHeroImg handleUrl={handleUrl} Gid={Gid} imageurl={imageLoaded ? formData.heroimage : null} />
                                        </div>
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                        </Accordion.Body>
                    </Accordion.Item>

                    {/* Button Settings Section */}
                    <Accordion.Item eventKey="4" className="border-0">
                        <Accordion.Header className="p-0 bg-transparent">
                            <Form.Label className="fw-bold mb-0 d-flex align-items-center"> <i class="fas fa-mouse me-2 text-primary"></i> Button Settings</Form.Label>
                        </Accordion.Header>
                        <Accordion.Body className="p-0">
                            <Card className="border-0 shadow-sm">
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <h6 className="mb-0">Button Active</h6>
                                                <label className="text-muted">Toggle to enable/disable the button</label>
                                            </div>
                                            <label className="switch">
                                                <input
                                                    className="form-control"
                                                    type="checkbox"
                                                    checked={formData.button?.enabled}
                                                    onChange={(e) => {
                                                        handleButtonChange('enabled', e.target.checked);
                                                        setEditingElement(e.target.checked ? 'button' : null);
                                                    }}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>

                                        {formData.button?.enabled && (
                                            <div className="mt-3">
                                                <Row>
                                                    <Col sm={12} md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Button Text</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={formData.button?.text}
                                                                onChange={(e) => handleButtonChange('text', e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Button URL</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={formData.button?.url}
                                                                onChange={(e) => handleButtonChange('url', e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <div className="mb-3">
                                                    <h6 className="mb-3">
                                                        Button Colors</h6>
                                                    <Row>
                                                        <Col sm={12} md={3}>
                                                            <Form.Label className="fw-bold"
                                                            >Color</Form.Label>
                                                        </Col>
                                                        <Col sm={12} md={9}>
                                                            <Form.Group className="mb-3">
                                                                <CompactPicker
                                                                    color={formData.button?.color}
                                                                    onChangeComplete={(color) =>
                                                                        handleButtonChange('color', color.hex)
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={12} md={3}>
                                                            <Form.Label className="fw-bold"
                                                            >
                                                                Background</Form.Label>
                                                        </Col>
                                                        <Col sm={12} md={9}>
                                                            <Form.Group className="mb-3">

                                                                <CompactPicker
                                                                    color={formData.button?.bgcolor}
                                                                    onChangeComplete={(color) =>
                                                                        handleButtonChange('bgcolor', color.hex)
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </Col>

                                                        <Col sm={12} md={3}>
                                                            <Form.Label className="fw-bold"
                                                            >
                                                                Border</Form.Label>
                                                        </Col>
                                                        <Col sm={12} md={9}>
                                                            <Form.Group className="mb-3">
                                                                <CompactPicker
                                                                    color={formData.button?.bordercolor}
                                                                    onChangeComplete={(color) =>
                                                                        handleButtonChange('bordercolor', color.hex)
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </div>

                                                {/* <div className="text-center mt-3">
                                                    <Button
                                                        style={{
                                                            color: formData.button?.color,
                                                            backgroundColor: formData.button?.bgcolor,
                                                            borderColor: formData.button?.bordercolor,
                                                            borderRadius: formData.button?.borderradius || '4px',
                                                            padding: formData.button?.size === 'sm' ? '0.25rem 0.5rem' :
                                                                formData.button?.size === 'lg' ? '0.5rem 1rem' : '0.375rem 0.75rem',
                                                            fontSize: formData.button?.size === 'sm' ? '0.875rem' :
                                                                formData.button?.size === 'lg' ? '1.25rem' : '1rem',
                                                        }}
                                                    >
                                                        {formData.button?.text || 'Button Preview'}
                                                    </Button>
                                                </div> */}
                                            </div>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Card>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Card>
        </div>
    );
};

export default HeroSectionEditor;